import { ArrowRight, KeyRound, Home, HandCoins } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SERVICES = [
  {
    key: "buy",
    icon: KeyRound,
    title: "BUY",
    desc: "Find a property that feels right.",
    cta: "Explore Buy Properties",
  },
  {
    key: "rent",
    icon: Home,
    title: "RENT",
    desc: "Find a place that fits your lifestyle.",
    cta: "Explore Rentals",
  },
  {
    key: "sell",
    icon: HandCoins,
    title: "SELL",
    desc: "Ready to sell your property?",
    cta: "Sell With Us",
  },
];

export const QuickServices = ({ onSearch, onEnquire }) => {
  const act = (key) => {
    if (key === "buy") onSearch({ lookingFor: "Buy", type: "", location: "", budget: "" });
    if (key === "rent") onSearch({ lookingFor: "Rent", type: "", location: "", budget: "" });
    if (key === "sell")
      return onEnquire({ interest: "Sell", message: "I want to sell my property. Please guide me with the next steps." });
  };

  return (
    <section className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-4" data-testid="quick-services">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
        {SERVICES.map((s, i) => (
          <Reveal key={s.key} delay={i * 0.1}>
            <div
              id={s.key}
              data-testid={`service-card-${s.key}`}
              className="group bg-white rounded-xl border border-line p-7 sm:p-9 h-full hover:border-gold-soft hover:shadow-[0_20px_50px_rgba(11,31,51,0.1)] hover:-translate-y-1.5 transition-all duration-400"
            >
              <div className="h-12 w-12 rounded-lg bg-navy flex items-center justify-center group-hover:bg-gold transition-colors duration-400">
                <s.icon size={21} className="text-gold group-hover:text-navy transition-colors duration-400" />
              </div>
              <h3 className="mt-6 font-display text-xl sm:text-2xl font-semibold text-navy tracking-wide">{s.title}</h3>
              <p className="mt-2.5 text-sm sm:text-base text-ink-soft leading-relaxed">{s.desc}</p>
              <button
                onClick={() => act(s.key)}
                data-testid={`service-${s.key}-button`}
                className="mt-6 inline-flex items-center gap-2 text-[14px] font-semibold text-navy border-b-2 border-gold pb-1 hover:gap-3.5 transition-all duration-300"
              >
                {s.cta} <ArrowRight size={15} />
              </button>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
